import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import kebabCase from 'lodash/kebabCase';
import { CompanyTeamMember } from '@/propTypes';
import TeamMemberLinkCell from './TeamMemberLinkCell';

function TeamMemberMainInfoCell({ data }) {
  return (
    <Box>
      <Typography data-testid={`main-info-${kebabCase(data?.displayName)}`}>
        {data?.displayName}
      </Typography>
      <TeamMemberLinkCell value={data?.email} />
    </Box>
  );
}

TeamMemberMainInfoCell.propTypes = {
  data: CompanyTeamMember.isRequired,
};

export default TeamMemberMainInfoCell;
